import { Global } from '../Global';
import { GetUploadTicketParam, OssUploadTicket } from '../models/Oss';
import { post } from '../utils/ApiUtil';

const getUploadTicket = async (
  param: GetUploadTicketParam,
): Promise<OssUploadTicket | null> => {
  if (Global.isMockMode()) {
    const ext = param.ext || 'pdf';
    const objectKey = `pdfcontracts/category_${Date.now()}.${ext}`;
    return {
      uploadUrl: `https://mock-upload.local/${objectKey}`,
      objectKey,
      accessUrl: `https://yuanling-new.oss-cn-shanghai.aliyuncs.com/${objectKey}`,
      headers: { 'Content-Type': param.contentType || 'application/pdf' },
    };
  }
  const resultOrErrorCode = await post<GetUploadTicketParam, OssUploadTicket>(
    '/oss/getUploadTicket',
    param,
  );
  if (typeof resultOrErrorCode === 'string') {
    return null;
  }
  return resultOrErrorCode;
};

export const OssApi = {
  getUploadTicket,
};
